 "use client"; // 确保组件只在客户端渲染

import { LoginForm } from '../../components/login-form'

export default function Page() {
  return (
    <div className='flex-1 flex items-center justify-center'>
      <LoginForm isLogin={true} />
    </div>
  )
}
